import AboutHero from "../sectionAboutUs/AboutHero";
import AboutClinic from "../sectionAboutUs/AboutClinic";
import AboutDoctor from "../sectionAboutUs/AboutDoctor";
import AboutValues from "../sectionAboutUs/AboutValues";
import Staff from "../sectionAboutUs/Staff";

const About = () => {
    return (
        <>
            <AboutHero />
            <AboutClinic />
            <AboutDoctor />
            <AboutValues/>
            <Staff/>
        </>
    );
};

export default About;
